import harvestCategoryString from 'Models/harvest/harvestCategoryString';
import harvestCrewString from 'Models/harvest/harvestCrewString';
import harvestDateString from 'Models/harvest/harvestDateString';
import harvestFieldsNameString from 'Models/harvest/harvestFieldsNameString';
import harvestTeamMembersNameString from 'Models/harvest/harvestTeamMembersNameString';
import harvestTeamsNameString from 'Models/harvest/harvestTeamsNameString';
import harvestVariety from 'Models/harvest/harvestVariety';
import harvestVolume from 'Models/harvest/harvestVolume';
import harvestWeightWithUnit from 'Models/harvest/harvestWeightWithUnit';

import { THarvestTableData } from '../types';

function getHarvestLogsRowData(
	harvest: THarvestTableData,
	hasActiveTimesheetsSubscription: boolean
) {
	return Object.values({
		date: harvestDateString(harvest),
		field: harvestFieldsNameString(harvest),
		category: harvestCategoryString(harvest),
		variety: harvestVariety(harvest),
		boxes: harvestVolume(harvest),
		weight: harvestWeightWithUnit(harvest),
		responsible: harvestCrewString(harvest),
		teams: harvestTeamsNameString(harvest, hasActiveTimesheetsSubscription),
		teamMembers: harvestTeamMembersNameString(
			harvest,
			hasActiveTimesheetsSubscription
		),
	});
}

export default getHarvestLogsRowData;
